import { Notify, getCssVar } from 'quasar';
import { i18n } from 'boot/i18n';

const getMessage = (title, message, options = {}) => {
  const { icon = 'far fa-circle-exclamation', iconColor = 'primary' } = options;
  const iconVariable = getCssVar(iconColor) || getCssVar('primary');
  return `
    <div class="q-pa-xl text-black text-center column items-center" style="width: 280px;">
      <div class="icon-animate text-black" style="--notification-icon: ${iconVariable}">
        <i class="q-icon ${icon} aria-hidden="true" role="img" style="font-size: 80px;"></i>
      </div>
      <div class="fs-16 fw-400 lh-20 q-my-lg text-capitalize">${title}</div>
      <div class="text-grey fs-14 fw-400 lh-18">${message}</div>
    </div>
  `;
};

const notifyHtmlProps = {
  html: true,
  classes: 'border-radius-20',
  color: 'white',
  timeout: 3000,
  position: 'bottom-right',
  actions: [
    {
      icon: 'far fa-xmark', color: 'grey',
    },
  ],
};

export const notifySuccess = (message) => {
  Notify.create({
    message,
    type: 'positive',
    color: 'primary',
    textColor: 'dark',
    icon: 'far fa-check',
    iconSize: '20px',
    timeout: 3000,
  });
};

export const notifyInfo = (title, message, options) => {
  Notify.create({
    message: getMessage(title, message, options),
    ...notifyHtmlProps,
  });
};

export const notifyError = (message) => {
  Notify.create({
    message: getMessage(i18n.global.t('text.error'), message, { iconColor: 'negative' }),
    ...notifyHtmlProps,
  });
};
